// import { fetchABExperimentData } from '@api/fetchers/experiments';
// import useMyInfo from '@api/hooks/auth/useMyInfo';
// import { getIsLoggedIn, getJWTToken } from '@api/selectors/auth';
// import useExperiments from '@stores/experiments';
// import { getExperimentVariation } from '@stores/selectors/experiments';
// import { abVariations } from '@utils/abHelper';
// import { useEffect } from 'react';
// import { REFERRAL_SUGGESTIONS_EXP } from './constants';

const useReferralCodeSuggestionsExp = () => {
  // const isLoggedIn = useMyInfo(getIsLoggedIn);
  // const meJwt = useMyInfo(getJWTToken);

  // const experimentVariation = useExperiments(
  //   getExperimentVariation(REFERRAL_SUGGESTIONS_EXP)
  // );
  // const isSuggestionFlow =
  //   experimentVariation && experimentVariation === abVariations.TEST_1;

  // useEffect(() => {
  //   if (isLoggedIn && !experimentVariation && meJwt) {
  //     fetchABExperimentData(REFERRAL_SUGGESTIONS_EXP, meJwt);
  //   }
  // }, [isLoggedIn, meJwt, experimentVariation]);
  // using hardcoded flag since fetchABExperimentData service is not working
  return { isSuggestionFlow: true };
};

export default useReferralCodeSuggestionsExp;
